// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
// import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/database'
// import 'firebase/auth'
import axios from 'axios'
import SocialSharing from 'vue-social-sharing'
import VueLocalForage from 'vue-localforage'

// import videoplayer from './components/videoPlayer'

Vue.use(VueLocalForage);

Vue.use(SocialSharing);
// const firebase = () => import('firebase/app');
// const firebasedb = () => import('firebase/database')

Vue.config.productionTip = false

Vue.config.performance = true

Vue.config.devtools = true

Vue.use(VueFire);

var firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAS9UQkwOa_qtDXDvJ2YDaG1ccok7JGfKs",
    authDomain: "garadirutti1.firebaseapp.com",
    databaseURL: "https://garadirutti1.firebaseio.com",
    projectId: "garadirutti1",
    storageBucket: "garadirutti1.appspot.com",
    messagingSenderId: "915819367365"
});

// var apiUrl = "https://us-central1-garadirutti1.cloudfunctions.net/api/";

var apiUrl = "./api/";

// window.firebaseApp = firebaseApp;

// console.log("typeof firebaseApp.database", typeof firebaseApp.database);

var db = firebaseApp.database();

/* eslint-disable no-new */
var GdRbase = new Vue({
	el: '#app',
	router,
	template: '<div><App :menuOpened="menuOpened"/></div>',
	data:{
		votes:0,
		videoID:'',
		recentN: 5,
		bestN: 5,
		vote_ready: false,
		upload_ready: false,
		menuOpened: false
	},
	components: { 
		App,
		// videoplayer
	},
	firebase:{
		anArray: db.ref('videos').orderByChild("votes").limitToLast( 100 ),
		mostRecent: db.ref('videos').orderByChild("date").limitToLast( 100 )
	},
	methods:{
		subVotesForVideo: function(videoID){
			// alert(videoID);
			var ref = db.ref("videos/"+videoID+"/votes");
			
			ref.on("value", function(dataSnapshot){
				// this.votes = dataSnapshot.val()
				if(dataSnapshot.val()!==null){
					this.votes = dataSnapshot.val()
				}
				// alert("hei")
				// alert(dataSnapshot);
			}, function(){}, this);
			/*
			ref.once("value")
			.then( (dataSnapshot) => {
				this.votes = dataSnapshot.val()
				// alert(dataSnapshot);
			})
			*/
		},
		unsubVotesForVideo: function(videoID){
			db.ref("videos/"+videoID+"/votes").off("value")
			this.votes = 0;
			console.log('unsubscribed');
		},
		openMenu: function(){
			this.menuOpened = true;
		},
		closeMenu: function(){
			this.menuOpened = false;
		},
		voteUp: function(videoID){
			if(videoID){
				axios.post(apiUrl+"voteUp", {
					videoID:videoID
				})
				.then(function(res){
					console.log(res);
				})
				.catch(function(error){
					console.log(error)
				})
			}
		},
		voteDown: function(videoID){
			axios.post(apiUrl+"voteDown", {
				videoID:videoID
			})
			.then(function(res){
				console.log(res);
			})
			.catch(function(error){
				console.log(error)
			})
		},
		addVideo: function(url){
			axios.post(apiUrl+"add", {
				url:url
			})
			.then(function(res){
				console.log(res);
			})
			.catch(function(error){
				console.log(error)
			})
		},
		/*
		saveToCookie: function(cookieName, values){
			setCookie(cookieName, values, 365);
		},
		getFromCookie: function(cookieName){
			getCookie(cookieName);
		},
		
		saveToLocal:function(key, value){
			this.$setItem(key, value, function(){
				console.log("saved")
			});
		},
		getFromLocal:function(key){

		}
		*/
	}
});

/*
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
*/

window.addEventListener('offline', function(e) { console.log('offline'); });

window.addEventListener('online', function(e) { console.log('online'); });


// WEBPACK FOOTER //
// ./src/main.js